var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 8.75C28 3.91825 24.0942 0 19.2778 0H8.81125C3.99489 -2.09859e-06 0.0891113 3.91825 0.0891113 8.75V19.25C0.0891113 24.0817 3.99489 28 8.81125 28L19.2778 28C24.0942 28 28 24.0817 28 19.25L28 8.75ZM8.81125 25.375C5.44451 25.375 2.70575 22.6275 2.70575 19.25L2.70575 8.75C2.70575 5.3725 5.44451 2.625 8.81125 2.625L19.2778 2.625C22.6446 2.625 25.3833 5.3725 25.3833 8.75L25.3833 19.25C25.3833 22.6275 22.6446 25.375 19.2778 25.375L8.81125 25.375ZM14.0442 7.00018C17.8976 7.00018 21.0219 10.1344 21.0219 14.0002C21.0219 17.8659 17.8976 21.0002 14.0442 21.0002C10.1907 21.0002 7.06647 17.8659 7.06647 14.0002C7.06647 10.1344 10.1907 7.00018 14.0442 7.00018ZM14.0442 18.3752C16.448 18.3752 18.4052 16.4117 18.4052 14.0002C18.4052 11.5869 16.448 9.62518 14.0442 9.62518C11.6404 9.62518 9.68311 11.5869 9.68311 14.0002C9.68311 16.4117 11.6404 18.3752 14.0442 18.3752ZM21.091 7.40775C20.5775 7.40775 20.1612 6.99014 20.1612 6.475C20.1612 5.95986 20.5775 5.54225 21.091 5.54225C21.6045 5.54225 22.0208 5.95986 22.0208 6.475C22.0208 6.99014 21.6045 7.40775 21.091 7.40775Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ae645d6a6b2d3932d1e583ca92fde24d.svg";
export { ForwardRef as ReactComponent };